import React, { useState, useEffect, ReactNode } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';


interface SSCopyToClipboardProps {
  timeoutTime?: number;
  copiedComponent?: ReactNode;
  children?: ReactNode;
  copyValue: string;
  onCopy?: () => void;
}

const SSCopyToClipboard: React.FC<SSCopyToClipboardProps> = ({ timeoutTime = 3000, copiedComponent, children, copyValue, onCopy }) => {

  const [justCopied, setJustCopied] = useState(false);

  const handleCopy = () => {
    setJustCopied(true);
    const timer = setTimeout(() => {
      setJustCopied(false);
    }, timeoutTime);
    if (onCopy) {
      onCopy();
    }
    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timer);


  };

  
  const copiedComp = copiedComponent || <span className="SSCopyToClipboard copied">COPIED</span>;
  const defaultChildren = children || <span className="SSCopyToClipboard">COPY</span>;
  const content = justCopied ? copiedComp : defaultChildren;

  return (
    <CopyToClipboard text={copyValue} onCopy={() => handleCopy()}>
      {content}
    </CopyToClipboard>
  );
};

export default SSCopyToClipboard;